import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

import Image from "./Image";

const COOKIE_NAME = "promo_universario26";
const IMAGE = "universario26.png";
const HIDDEN_PATHS = [
  "/checkout",
  "/minha-conta",
  "/cart",
  "/login",
  "/cadastro",
  "/questionario",
  "/anamnese-v2",
  "/solucoes-purissima",
  "/frequencia",
  "/sabores",
];

// Sem `expires`, o js-cookie cria um cookie de sessão (some ao fechar o navegador).
const PromoModal = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  const isHidden = HIDDEN_PATHS.some((path) => pathname.startsWith(path));

  useEffect(() => {
    if (isHidden || Cookies.get(COOKIE_NAME)) {
      setShow(false);
      return;
    }
    Cookies.set(COOKIE_NAME, "1", { sameSite: "lax" });
    setShow(true);
  }, [isHidden]);

  if (isHidden) return null;

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      size="lg"
      contentClassName="bg-transparent border-0 w-auto mx-auto"
    >
      <button
        type="button"
        className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
        style={{ zIndex: 2 }}
        aria-label="Fechar"
        onClick={() => setShow(false)}
      />
      <Image
        image={IMAGE}
        title="Promoção Universário 26"
        webp
        fetchpriority="high"
        width="987"
        height="658"
        className="img-fluid rounded d-block"
        style={{ maxHeight: "calc(100vh - 3.5rem)", width: "auto" }}
      />
    </Modal>
  );
};

export default PromoModal;
